import React from 'react';
import { Brain, Github, Mail, FileText } from 'lucide-react';
import icon_logo from '../assets/icon_logo.png';

/**
 * Footer Component
 * Footer minimale ancorato al basso della pagina
 * Coerente con lo stile dell'header della dashboard
 */
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white shadow-sm border-t border-gray-200 mt-auto">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Sezione sinistra - Brand e Copyright */}
          <div className="flex items-center space-x-3">
            <img 
              src={icon_logo} 
              alt="SematorPRO" 
              style={{ 
                width: '100%',
                maxWidth: '50px' 
              }}
            />
          </div>

          {/* Sezione centrale - Versione */}
          <div className="flex items-center text-sm text-gray-500">
            <span className="px-2 py-1 bg-gray-100 rounded text-xs font-mono">
              v1.0.0
            </span>
            <span className="px-2 py-1 bg-gray-100 rounded text-xs font-mono">
              SemantorPRO @ 2025-2026 Promo Inside Srls Unipersonale 12957351005 - 00154 Roma. All Rigths Reserved.
            </span>
          </div>

          {/* Sezione destra - Links */}
          <div className="flex items-center space-x-6">
            <a
              href="/docs"
              className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition"
              title="Documentazione"
            >
              <FileText className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Docs</span>
            </a>
            <a
              href="mailto:support@semantorpro.com"
              className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition"
              title="Supporto"
            >
              <Mail className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Support</span>
            </a>
            <a
              href="https://www.semantorpro.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition"
              title="Privacy Policy"
            >
              <span>Privacy Policy</span>
            </a>
            <a
              href="https://www.semantorpro.com/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition"
              title="Cookie Policy"
            >
              <span>Cookie Policy</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}